export var ValidationSummaryCssClass;
(function (ValidationSummaryCssClass) {
    ValidationSummaryCssClass["Base"] = "iress-validation-summary";
    ValidationSummaryCssClass["List"] = "iress-validation-summary__list";
})(ValidationSummaryCssClass || (ValidationSummaryCssClass = {}));
//# sourceMappingURL=validation-summary.types.js.map